import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

const ListDirectory = () => {
  const { SetSharedObject, userRole, userToken, sharedObject, userSession } =
    useUserStore((state) => ({
      SetSharedObject: state.SetSharedObject,
      userSession: state.userSession,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
    }));

  const [userObj, setUserObj, detailObj] = useState([]);
  const [showGridFlag, SetShowGridFlag] = useState(false);
  const [searchNameVal, setSearchNameVal] = useState(false);
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState(false);
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [selectedGridProducts, setSelectedGridProducts] = useState([]);

  useEffect(() => {
    if (sharedObject.AdvSearchObj) {
      if (sharedObject.AdvSearchObj.length > 0) {
        SearchList(sharedObject.AdvSearchObj);
        SetShowGridFlag(true);
      } else {
        setUserObj([]);
        SetShowGridFlag(false);
        setSelectedProducts(false);
      }
    }
  }, [sharedObject.AdvSearchObj]);

  // useEffect(() => {
  //   if (directoryType !== "") {
  //     defaultSearch(directoryType);
  //     SetShowGridFlag(true);
  //     setSelectedProducts(directoryType);
  //   } else {
  //     setUserObj([]);
  //     SetShowGridFlag(false);
  //     setSelectedProducts(false);
  //   }
  // }, [directoryType]);

  const SearchList = (obj) => {
    setSelectedGridProducts([]);
    let tempObj = [];
    for (const row of obj) {
      let cs = (
        <a
          href="javascript:void(0);"
          underline="none"
          className="font-weight-bold"
          onClick={() => {
            searchName(row, "show");
          }}
        >
          {row.name}
        </a>
      );
      row.GridLinkCourse = cs;
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };

  const searchName = async (row) => {
    setSelectedGridProducts([row]);
    setProcessing(true);
    let call =
      "/directorySearch/GetDetailById?searchById=" +
      row.id +
      "&searchType=" +
      row.DirectoryType;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      var dt = res.data.data;
      await SetSharedObject("userDirectSearch", dt);
      $("#detailsDirectoryModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const NameSearchFunc = async () => {
    if (!searchNameVal.trim()) return;
    let o = searchNameVal.split(" ");
    let obj = {
      DirectoryType: selectedProducts,
      FirstName: o[0],
      LastName: o[1] ? o[1] : null,
    };
    setProcessing(true);
    let call = "/directorySearch/Search";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      if (res.data.data.pageItems.length > 0) {
        SearchList(res.data.data.pageItems);
        SetShowGridFlag(true);
      }
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const SendMessage = async () => {
    setProcessing(true);
    let call = "/directorySearch/DirectorySendEmail";
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      let str = "";
      if (dt) {
        const MailtoAddress = selectedGridProducts.map((el) => {
          str += `${el.directEmail};`;
          return `${el.directEmail};`;
        });
        if (typeof window !== "undefined") {
          window.open("/webmail/Home/Index?MailtoAddress=" + str, "_self");
        }
      } else {
        $("#DirAlertModal").modal("show");
      }
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const AddContacts = async (val) => {
    setProcessing(true);
    const addObj = selectedGridProducts.map((el) => {
      const obj = {
        UserName: el.name,
        Email: el.directEmail,
        Address: el.address,
        City: el.city,
        State: el.state,
        Zip: el.zip,
      };
      return obj;
    });
    let call = "/directorySearch/addEmailToContact";
    const res = await CallAPI(call, addObj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      $("#DirConfirmModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const defaultSearch = async (type) => {
    let obj = {
      UserId: null,
      OrganizationId: null,
      OrganizationKind: "",
      DirectorySource: "All",
      DirectoryType: type,
      SearchByName: null,
      FirstName: null,
      LastName: null,
      OrganizationName: null,
      NationalProviderID: null,
      ContactEmail: null,
      DirectEmail: null,
      Address: null,
      City: null,
      Zip: null,
      SpecialitySpecialization: null,
      DomainName: null,
      Resultsize: 0,
    };

    setProcessing(true);
    let call = "/directorySearch/Search";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      var dt = res.data.data.pageItems;
      SearchList(dt);
      SetShowGridFlag(true);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const setType = (e) => {
    var selectedDirectory = e.target.value;
    setSelectedProducts(selectedDirectory);
    defaultSearch(e.target.value);
  };

  function isNullUndefinedOrEmpty(x) {
    console.log(userSession);
    return (
      x === null ||
      x === void 0 ||
      (x.hasOwnProperty("length") && x.length === 0)
    );
  }

  return (
    <div className="ListDirectory">
      {errDetailFlag ? (
        <div
          className={`alert alert-danger`}
          dangerouslySetInnerHTML={{ __html: errDetailMsg }}
        />
      ) : null}
      <div className="HeaderDirectory">
        <header className="ht-5 sp-t">
          <div className="admin-title mid-main-bar  sp-pad7">
            <i
              className="bi bi-card-checklist sp-margin5"
              aria-labelledby="Directory Search"
              alt="Directory Search Icon"
            ></i>
            Directory Search&nbsp;
            {selectedProducts === "Providers" ? (
              <>for Providers</>
            ) : selectedProducts === "Organizations" ? (
              <>for Organizations</>
            ) : null}
          </div>

          {/*Search by name
          <div className="spacer-inline spacer-margin6">
            <div className="input-group">
              <input
                type="search"
                className="form-control shade-2"
                placeholder="Enter Name"
                aria-label="Enter Name"
                aria-describedby="Search Users by Name"
                onChange={(el) => setSearchNameVal(el.target.value)}
              />
              <div className="input-group-append">
                <button
                  className="input-group-text btn btn-secondary shade-2"
                  id="basic-addon2"
                  onClick={NameSearchFunc}
                >
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>*/}

          {/*Advanced Search*/}
          <div className="spacer-inline v-top w-md12">
            <select
              className="form-control w-md10 spacer-inline spacer-margin6 shade-2"
              onChange={setType}
              value={selectedProducts}
            >
              <option value="">DIRECTORY TYPE</option>
              <option value="Providers">Provider</option>
              <option value="Organizations">Organization</option>
            </select>
            <button
              className="btn btn-primary shade-1 "
              data-target="#advDirSearchModal"
              data-toggle="modal"
            >
              Search
            </button>
          </div>
        </header>
      </div>

      {showGridFlag ? (
        <section className="grid-layout">
          <DataTable
            value={userObj}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
            dataKey="id"
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            columnResizeMode="expand"
            resizableColumns
            selectionMode={"checkbox"}
            selection={selectedGridProducts}
            onSelectionChange={(e) => {
              setSelectedGridProducts(e.value);
            }}
            selectionAutoFocus={false}
          >
            {sharedObject.getUserEmails &&
            sharedObject.getUserEmails.length > 0 ? (
              <Column selectionMode="multiple" className="w-s"></Column>
            ) : null}
            <Column field="GridLinkCourse" header="Name" sortable></Column>
            {/*<Column*/}
            {/*  field="DirNpi"*/}
            {/*  header="NPI"*/}
            {/*  className="w-md1"*/}
            {/*  sortable*/}
            {/*></Column>*/}
            <Column
              field="directEmail"
              header="Direct Email"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="emailPurpose"
              header="Email Purpose"
              sortable
            ></Column>
            <Column
              field="address"
              header="Address"
              className="truncate"
              sortable
            ></Column>
            <Column field="city" header="City" sortable></Column>
            <Column
              field="state"
              header="State"
              className="w-sm"
              sortable
            ></Column>
            <Column field="zip" header="Zip" className="w-sm" sortable></Column>

            {/*{sharedObject?.AdvSearchAnswers?.DirectoryType !== "Providers" ? (*/}
            {/*  <Column field="orgKind" header="Organization Type" sortable ></Column>*/}
            {/*) : null}*/}
          </DataTable>
          {sharedObject.getUserEmails &&
          sharedObject.getUserEmails.length > 0 ? (
            <div className="paging">
              <div className="spacer-inline spacer-margin9">
                <button
                  className="btn btn-primary"
                  onClick={(el) => AddContacts()}
                  disabled={selectedGridProducts.length === 0}
                >
                  Add to Contacts
                </button>

                <button
                  className="btn btn-primary spacer-margin2"
                  disabled={selectedGridProducts.length === 0}
                  onClick={(el) => SendMessage()}
                >
                  Send Message
                </button>
              </div>
            </div>
          ) : null}
        </section>
      ) : (
        <section className="empty-grid">
          There are currently no results.
        </section>
      )}

      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default ListDirectory;
